const priceList = [
    { startPrice: '0', endPrice: '4000' },
    { startPrice: '4001', endPrice: '8000' },
    { startPrice: '8001', endPrice: '12000' },
    { startPrice: '12001', endPrice: '16000' },
    { startPrice: '16001', endPrice: '20000' },
    { startPrice: '20001', endPrice: '40000' },
]

export default priceList;